/* AE (Sep 2026): fixed 'wishlist_item_length is not defined' error on every heart click,
   empty-wishlist message now shows again after removing the last item on the Wishlist page,
   and the page wrapper keeps its own class when items exist. */
class WishlistProduct extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onAddWishlist);
    this.LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist";
    this.LOCAL_STORAGE_DELIMITER = ",";
    this.BUTTON_ACTIVE_CLASS = "active";
    this.onAddActiveClass();
    this.WishlistItemCounter();
  }

  WishlistItemCounter() {
    let WISHLIST_ITEM_COUNT = document.querySelectorAll(".wishlist__count");
    let wishlist_item_length = this.getWishlist().length;
    if (WISHLIST_ITEM_COUNT) {
      WISHLIST_ITEM_COUNT.forEach((singleItem) => {
        singleItem.innerText = wishlist_item_length;
      });
    }
  }

  onAddActiveClass() {
    const wishlistAddedButton = this.querySelector("button");
    if (wishlistAddedButton != null) {
      let productHandle = wishlistAddedButton.dataset.productHandle || false;
      if (!productHandle)
        return console.error(
          "[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
        );
      if (this.wishlistContains(productHandle))
        wishlistAddedButton.classList.add(this.BUTTON_ACTIVE_CLASS);
    }
  }

  onAddWishlist() {
    const wishlistItem = this.querySelector("button");
    if (!wishlistItem) return;
    let productHandle = wishlistItem.dataset.productHandle || false;
    if (!productHandle)
      return console.error(
        "[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
      );

    this.updateWishlist(productHandle);

    this.WishlistItemCounter();

    let grid = document.querySelector("[grid-wishlist]") || false;

    if (grid && grid.contains(this)) {
      const card = this.closest(".product__card");
      const col = card ? (card.closest(".col") || card) : null;
      if (col) col.remove();
    } else {
      wishlistItem.classList.add("loading", "adding");
      setTimeout(function () {
        wishlistItem.classList.remove("loading");
        wishlistItem.classList.toggle("active");
      }, 500);

      setTimeout(function () {
        wishlistItem.classList.remove("adding");
      }, 1000);
    }

    let wishlist_item_length = this.getWishlist().length;
    if (grid && wishlist_item_length <= 0) {
      const page = document.querySelector(".wishlist-page");
      if (page) page.classList.remove("wishlist_exists");
    }
  }

  getWishlist() {
    let wishlist;
    try { wishlist = localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY) || false; } catch (e) { wishlist = false; }
    if (wishlist) return wishlist.split(this.LOCAL_STORAGE_DELIMITER).filter(Boolean);
    return [];
  }

  setWishlist(array) {
    let wishlist = array.join(this.LOCAL_STORAGE_DELIMITER);
    try {
      if (array.length) localStorage.setItem(this.LOCAL_STORAGE_WISHLIST_KEY, wishlist);
      else localStorage.removeItem(this.LOCAL_STORAGE_WISHLIST_KEY);
    } catch (e) {}
    return wishlist;
  }

  updateWishlist(handle) {
    let wishlist = this.getWishlist();
    let indexInWishlist = wishlist.indexOf(handle);
    if (indexInWishlist === -1) wishlist.push(handle);
    else wishlist.splice(indexInWishlist, 1);
    return this.setWishlist(wishlist);
  }

  wishlistContains(handle) {
    let wishlist = this.getWishlist();
    return wishlist.indexOf(handle) !== -1;
  }
}
if (!customElements.get("wishlist-item")) customElements.define("wishlist-item", WishlistProduct);

let newWishlistObj = new WishlistProduct();

var setupGrid = function (grid) {
  var wishlist = newWishlistObj.getWishlist();
  var page = document.querySelector(".wishlist-page");

  if (wishlist.length > 0 && page) {
    page.classList.add("wishlist_exists");
  }

  var requests = wishlist.map(function (handle) {
    var productTileTemplateUrl = "/products/" + handle + "?view=wishlist";
    return fetch(productTileTemplateUrl).then(function (res) {
      if (res.status == 200) {
        return res.text();
      }
      return "";
    }).catch(function () { return ""; });
  });

  Promise.all(requests).then(function (responses) {
    var html = responses.join("");
    grid.innerHTML = html;
    if (!html.trim() && page) page.classList.remove("wishlist_exists");
  });
};

function aeInitWishlistGrid() {
  let grid = document.querySelector("[grid-wishlist]") || false;
  if (grid) setupGrid(grid);
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", aeInitWishlistGrid);
else aeInitWishlistGrid();
